import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from './Button';
import CloseButton from './CloseButton';
import {
  BreakPoint,
  Color,
  FontSize,
  Font,
  Coordinates,
} from '../styles/constants';

const Box = styled.div`
  background-color: ${Color.white};
  border-top: solid 1px ${Color.border.darkRed};
  box-sizing: border-box;
  font-family: ${Font.default};
  padding: 16px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  @media (min-width: ${BreakPoint.desktop}) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
    width: 456px;
    bottom: 32px;
    top: auto;
    left: auto;
    right: ${Coordinates.right};
  }

  * {
    font-family: ${Font.default};
  }
`;

const FlexBox = styled.div`
  display: flex;
`;

const MessageBox = styled(FlexBox)`
  justify-content: flex-end;
`;

const Message = styled.div`
  color: ${Color.text.black};
  font-size: ${FontSize.medium};
  margin-top: 8px;

  @media (min-width: ${BreakPoint.desktop}) {
    flex: 1;
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

const Buttons = styled(FlexBox)`
  margin-top: 16px;
`;

const LeftButton = styled.div`
  flex: 1;
  margin-right: 8px;
`;

const RightButton = styled.div`
  flex: 1;
  margin-left: 8px;
`;

const Close = styled.div`
  margin-left: 20px;
`;

const Toast = props =>
  props.isOpen && (
    <Box className={props.className}>
      <MessageBox>
        <Message>{props.message}</Message>
        <Close>
          <CloseButton onClick={props.onCloseClick} color="red" />
        </Close>
      </MessageBox>
      <Buttons>
        <LeftButton>
          <Button onClick={props.onCancelClick}>{props.closeLabel}</Button>
        </LeftButton>
        <RightButton>
          <Button primary onClick={props.onActionClick}>
            {props.actionLabel}
          </Button>
        </RightButton>
      </Buttons>
    </Box>
  );

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  onActionClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  actionLabel: PropTypes.string.isRequired,
  closeLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
};

Toast.defaultProps = {
  onActionClick: () => {},
  onCancelClick: () => {},
  onCloseClick: () => {},
  isOpen: false,
};

export default Toast;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/Toast.jsx